"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useEntityUpdateQuery = void 0;
var client_1 = require("@apollo/client");
var lodash_1 = require("lodash");
var use_entity_definition_named_1 = require("./use-entity-definition-named");
var useEntityUpdateQuery = function (entityTypeName, query, options) {
  if (options === void 0) {
    options = {};
  }
  var definition = (0, use_entity_definition_named_1.useEntityDefinitionNamed)(entityTypeName);
  var _a = options.valueKeys,
    valueKeys = _a === void 0 ? function (fieldName) {
      return ['url', 'id', 'text'];
    } : _a;
  var result = (0, client_1.useQuery)(query, (0, lodash_1.omit)(options, ['valueKeys']));
  var data = result.data,
    loading = result.loading,
    error = result.error;
  var entityData = data;
  if (!loading && !error) {
    var transform_1 = function (val, key, scalar) {
      if (scalar === void 0) {
        scalar = false;
      }
      if ((0, lodash_1.isArray)(val)) {
        return {
          value: val.map(function (item) {
            return transform_1(item, key, true);
          })
        };
      }
      if ((0, lodash_1.isObject)(val)) {
        // lookup keys
        /* @ts-ignore */
        var isContentNode = val.__typename === 'ContentNode';
        var vk = isContentNode ? (0, lodash_1.without)(valueKeys(key), 'id') : valueKeys(key);
        var valueKey = (0, lodash_1.find)(vk, function (key) {
          return (0, lodash_1.get)(val, key);
        }) || (0, lodash_1.first)(isContentNode ? (0, lodash_1.without)((0, lodash_1.keys)(val), '__typename', 'id') : (0, lodash_1.without)((0, lodash_1.keys)(val), '__typename'));
        if (valueKey) {
          var value = val[valueKey];
          return scalar ? value : {
            value: value
          };
        }
        return {
          value: ''
        };
      }
      return {
        value: val
      };
    };
    // transform the data so that all object values are scalar, taking a number of known values keys
    var dict = data;
    var entityData_1 = dict[definition.updateTypeName];
    if ((0, lodash_1.isObject)(entityData_1)) {
      return __assign(__assign({}, result), {
        entityData: entityData_1,
        data: (0, lodash_1.mapValues)(entityData_1, function (value, key) {
          return transform_1(value, key);
        })
      });
    }
  }
  return __assign(__assign({}, result), {
    data: data,
    entityData: entityData
  });
};
exports.useEntityUpdateQuery = useEntityUpdateQuery;